import { createAction } from '@reduxjs/toolkit';
const prefix = 'busylight';
export const busylightActions = {
    getConnectedStatus: createAction(`${prefix}/getConnectedStatus`),
    getConnectedStatusFulfilled: createAction(`${prefix}/getConnectedStatusFulfilled`),
    getConnectedStatusRejected: createAction(`${prefix}/getConnectedStatusRejected`),
    setStatus: createAction(`${prefix}/setStatus`),
    setStatusFulfilled: createAction(`${prefix}/setStatusFulfilled`),
    setStatusRejected: createAction(`${prefix}/setStatusRejected`),
    ring: createAction(`${prefix}/ring`),
    ringFulfilled: createAction(`${prefix}/ringFulfilled`),
    ringRejected: createAction(`${prefix}/ringRejected`),
    stop: createAction(`${prefix}/stop`),
    stopFulfilled: createAction(`${prefix}/stopFulfilled`),
    stopRejected: createAction(`${prefix}/stopRejected`),
};
